import { apiClient } from '../api';

export const investigationsApi = {
  async getSettings() {
    const { data } = await apiClient.get('/api/investigations/settings');
    return data;
  },

  async setEnabled(enabled) {
    const { data } = await apiClient.put('/api/investigations/settings', { enabled });
    return data;
  },

  async list(limit = 5) {
    const { data } = await apiClient.get('/api/investigations', { params: { limit } });
    return data.investigations;
  },
};
